module.exports = "/packs/media/images/friends_2-0c43b912f6e312dd024142061442c1b2.jpg";